import React from "react";
import PrivacySecurityImg1 from "../../assets/images/PrivacySecurityImg1.svg";
import PrivacySecurityImg2 from "../../assets/images/PrivacySecurityImg2.svg";

import styles from "./PoliciesAndTerms.module.css";

export default function PrivacyPolicies() {
  return (
    <section
      className={`${styles.termsBlockContainer} ${styles.privacyPolicies}`}
    >
      <div className={styles.container}>
        <h3>
          Privacy & <span>Security Policies</span>
        </h3>
        <h5>
          Comprehensive data protection and security measures ensuring member
          privacy, platform integrity, and responsible information management.
        </h5>

        <div className={styles.cards}>
          <div className={styles.card}>
            <div className={styles.heading}>
              <figure>
                <img src={PrivacySecurityImg1} alt={"Privacy Policy"} />
              </figure>
              <h4>Privacy Policy</h4>
            </div>

            <h6>Data Collection</h6>
            <p className={`${styles.icons} ${styles.user}`}>
              Personal identification information (name, contact details, affiliation)
            </p>
            <p className={`${styles.icons} ${styles.education}`}>
              Academic credentials, publications, and professional profile data
            </p>
            <p className={`${styles.icons} ${styles.email}`}>
              Communication preferences and platform interaction records
            </p>

            <h6>Purpose of Data Usage</h6>
            <p className={`${styles.icons} ${styles.policy}`}>
              Facilitating mentorship connections and academic collaboration
            </p>
            <p className={`${styles.icons} ${styles.research}`}>
              Managing memberships, events, and publishing processes
            </p>
            <p className={`${styles.icons} ${styles.event}`}>
              Research analytics, reporting insights, and service improvement
            </p>
            <p className={`${styles.icons} ${styles.policy}`}>
              Event notifications, updates, and official communication
            </p>

            <h6>User Rights</h6>
            <p className={`${styles.icons} ${styles.eye}`}>
              Access to personal data maintained by IMPARC
            </p>
            <p className={`${styles.icons} ${styles.edit}`}>
              Request correction or updating of profile information
            </p>
            <p className={`${styles.icons} ${styles.delete}`}>
              Request deletion of data, subject to regulatory and contractual obligations
            </p>
            <button className={styles.cardBtn}>View Full Privacy Policy</button>
          </div>
          <div className={styles.card}>
            <div className={styles.heading}>
              <figure>
                <img src={PrivacySecurityImg2} alt={"Data & Security Policy"} />
              </figure>
              <h4>Data & Security Policy</h4>
            </div>
            <h6>Security Measures</h6>
            <p className={`${styles.icons} ${styles.ssl}`}>
              Secure data transmission protocols (SSL encryption)
            </p>
            <p className={`${styles.icons} ${styles.secure}`}>
              Protected database storage and secure hosting infrastructure
            </p>
            <p className={`${styles.icons} ${styles.key}`}>
              Multi-factor authentication where applicable
            </p>
            <h6>Access Control</h6>
            <p className={`${styles.icons} ${styles.groupUser}`}>
              Role-based system permissions
            </p>
            <p className={`${styles.icons} ${styles.watch}`}>
              Periodic access audits and internal review mechanisms
            </p>
            <p className={`${styles.icons} ${styles.block}`}>
              Automatic session timeouts and credential safeguards
            </p>
            <h6>Incident Response</h6>
            <p className={`${styles.icons} ${styles.warning}`}>
              Continuous monitoring for security vulnerabilities
            </p>
            <p className={`${styles.icons} ${styles.phone}`}>
              Immediate breach notification procedures (if applicable)
            </p>
            <p className={`${styles.icons} ${styles.watch2}`}>
              Structured data backup and recovery protocols
            </p>
            <button className={styles.cardBtn}>
              View Full Security Policy
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
